import { faPencil, faPlane, faPlus, faPlusCircle, faSearch, faTrash, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useStore } from '../../../contexts/StoreProvider';
import { IUser } from '../../../models/IUser';
import Pagination from '../../../shared-components/Grid/Pagination';
import { formatMessage } from '../../../translations/format-message';
import InputTag from '../InputTag/InputTag';
import EditProfilePopup from './EditProfile/EditProfilePopup';
import EditProfileHOC from './hoc/EditProfileHOC';
import LoaderButton from '../../../shared-components/Button/LoaderButton';
import { useNavigate } from 'react-router-dom';
import RoutesConstants from '../../../shared-components/Routes/routes.constants';
import DeletePopup from '../../agent-dashboard/components/Delete/DeletePopup';
import DeletePopupHOC from '../../agent-dashboard/hoc/DeletePopupHOC';
import CreateProfileHOC from './hoc/CreateProfileHOC';
import CreateProfilePopup from './CreateProfile/CreateProfilePopup';
import { initialState as CreateUserInitialState } from '../../../core/initial-state/registration-state';
import { pageLimitOptions } from '../../../constants/options.constant';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';
import { Backdrop } from '@mui/material';
import CustomPagination from '../../../shared-components/Pagination/CustomPagination';

const Users = (props: any) => {
    const navigate = useNavigate();
    const { adminStore, authStore } = useStore();
    const { createProfile,
        updateProfile,
        deleteUser,
        allUsers,
        getUserListState,
        setSelectedUserUsingEmail,
        updateFilteredUserText,
        getSelectedUserDetails,
        updateSearchingUserText,
        getAllUsers,
        searchingFilterUserTabState,
        addUpdateUserState,
        resetAddUpdateUserState,
        deleteUserState,
        resetDeleteUser,
        userPaginationState,
        updateUserPageNumber,
        updateUserPageSize,
        resetUserPagingState
    } = adminStore;
    const { loginUser, loginUserState, resetLoginUser, getEmail} = authStore;

    const UsersArr = [{ "text": "everyone", "className": 'filter-wrap ms-2', "filterName": "Everyone" }, { "text": "admin", "className": 'filter-wrap ms-2', "filterName": "Admin" }, { "text": "trainer", "className": 'filter-wrap ms-2', "filterName": "Trainer" }, { "text": "personal", "className": 'filter-wrap ms-2', "filterName": "Personal" }, { "text": "free", "className": 'filter-wrap ms-2', "filterName": "Free" }, { "text": "agent", "className": 'filter-wrap ms-2', "filterName": "Agent" }]

    const [UserArr, setUsersArr] = useState(UsersArr)
    const [emailSelectedForLogin, setEmailSelectedForLogin] = useState<string>("");
    const [deleteUserId, setDeleteUserId] = useState<number>(-1);
    const [deleteUserName, setDeleteUserName] = useState<string>("");
    const [searchText, setSearchText] = useState<string>("");
    const [isSearchPerformed, setIsSearchPerformed] = useState<boolean>(false);
    useEffect(() => {
        if (userPaginationState.PagingDetails.isPagerChange === true) {
            callGetAllUsers();
            resetUserPagingState();
        }
    }, [userPaginationState.PagingDetails.isPagerChange]);

    //initial-load
    useEffect(() => {
        handleSetActiveTab("everyone", "Everyone");
    }, []);

    // This will refresh the page when the user login is successfull.s
    useEffect(() => {
        if (loginUserState.success) {
            resetLoginUser();
            navigate(RoutesConstants.Login);
        }
    }, [loginUserState.success]);

    useEffect(() => {
        if (loginUserState.error) {
            setEmailSelectedForLogin("");
            resetLoginUser();
        }
    }, [loginUserState.error]);

    useEffect(() => {
        if (addUpdateUserState.success || deleteUserState.success) {
            callGetAllUsers();
            resetAddUpdateUserState();
        }
    }, [addUpdateUserState.success, deleteUserState.success]);

    useEffect(() => {
        if (deleteUserState.success) {
            callGetAllUsers();
            resetDeleteUser();
            props.deletePopupToggleHandler();
        }
    }, [deleteUserState.success]);

    useEffect(() => {
        if (searchText.replace(/\s+/g,' ').trim()  === '' && isSearchPerformed) {
            setIsSearchPerformed(() => false);
            setSearchText(() => '');
            callGetAllUsers();
        }
    }, [searchText]);

    const callGetAllUsers = () => {
        getAllUsers(userPaginationState.PagingDetails.PageNo, userPaginationState.PagingDetails.PageSize, searchText.replace(/\s+/g,' ').trim() , searchingFilterUserTabState.filter);
    };

    const handleSearch = () => {
        updateUserPageNumber(1, true);
        setIsSearchPerformed(() => true);
    }

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter' && searchText.replace(/\s+/g,' ').trim() !== '') {
            handleSearch();
        }
    }

    const [disablePagination, setDisablePagination] = useState<boolean>(false);

    const onPageChanged = (pageNumber: number) => {
        updateUserPageNumber(pageNumber);
    };

    const onPageLimitChanged = (evt: any) => {
        updateUserPageSize(parseInt(evt.target.value));
    };

    const handleSetActiveTab = (key: string, filterName: string) => {
        updateFilteredUserText(filterName);
        updateUserPageNumber(1, true);
        setUsersArr((userArr) => {
            const newActiveTab = userArr.map((tab) => {
                return {
                    ...tab,
                    className: tab.text === key ? 'filter-wrap ms-2 active' : 'filter-wrap ms-2',
                };
            });
            return newActiveTab;
        });
    };
    const performSearch = (searchText: string) => {
        updateUserPageNumber(1, true);
    };

    const handleEditProfilePopup = async (email: string) => {
        // Fetch the data from the 
        // await getUserDetail(email);
        setSelectedUserUsingEmail(email);
        props.editProfilePopupToggleHandler();
    }

    const handleUserLoginByAdmin = (email: string) => {
        setEmailSelectedForLogin(email);
        // console.log(email);
        loginUser(email);
    }

    const handleCreateTrainerAccountModal = () => {
        props.createProfilePopupToggleHandler();
    }

    const handleCreateProfileModalClose = () => {
        props.createProfilePopupToggleHandler();
    }

    const handleEditProfileModalClose = () => {
        props.editProfilePopupToggleHandler();
    }

    const deleteUserHandler = (userId: number) => {
        deleteUser(userId);
    }

    const handleDeleteClick = (userId: number, userName: string) => {
        setDeleteUserId(userId);
        setDeleteUserName(userName);
        props.deletePopupToggleHandler();
    };

    return (
        <>
            {props.showCreateProfilePopup &&
                (<CreateProfilePopup modalClosed={handleCreateProfileModalClose} isLoading={addUpdateUserState.inProgress} initialValues={CreateUserInitialState} submitHandler={createProfile} />)
            }

            {props.showEditProfilePopup &&
                (<EditProfilePopup modalClosed={handleEditProfileModalClose} isLoading={addUpdateUserState.inProgress} initialValues={getSelectedUserDetails} submitHandler={updateProfile} />)
            }

            {props.showDeletePopup && (
                <DeletePopup modalClosed={props.deletePopupToggleHandler} isLoading={deleteUserState.inProgress} Id={deleteUserId} Title={deleteUserName} deleteHandler={deleteUserHandler} />
            )}
            <div className="dashboardTopbar">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-7">
                            <InputTag size="search" icon={true} inputValue={setSearchText} onKeyDown={handleKeyDown} inputvalue={searchText} inputType="text" clickedFn={handleSearch} placeholderText={formatMessage("search")} FaIcon={faSearch} />
                        </div>
                        <div className="col-5 text-md-end text-center">
                            <button className='btn btn-primary' onClick={handleCreateTrainerAccountModal}><i className='fa fa-plus'></i> <FormattedMessage id='create_trainer_account' /></button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container'>
                <div className='mb-3' >
                    {
                        !(getUserListState.inProgress || (!getUserListState.success && getUserListState.error === '' ))
                        &&
                        UserArr.map((user, index) => <span key={index} >
                            <button type='button' className={user.className} onClick={() => handleSetActiveTab(user.text, user.filterName)}>{formatMessage(user.text)}</button>
                        </span>)
                    }
                </div>
                <div className='row'>
                    {/* <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box> */}
                    {/* <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress disableShrink={true}/>
                    </Box> */}
                    {/* <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={true}
                        
                        // onClick={handleClose}
                        >
                        <CircularProgress color="inherit" />
                    </Backdrop> */}
                    {
                        getUserListState.inProgress || (!getUserListState.success && getUserListState.error === '' ) 
                        ?
                        <>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '150px'}}>
                                <CircularProgress disableShrink={true}/>
                            </Box>
                        </>
                        :
                        allUsers.length > 0 ? (
                            <>
                                {allUsers.map((data, index: number) => (
                                    <div className='col-xl-3 col-lg-4 col-md-6 col-12 mt-3 ' key={index}>
                                        <div className="card borderedCard">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-12 text-center">
                                                        <h3 className="mb-0 card_name" title={`${data.FirstName} ${data.LastName}`}>{`${data.FirstName} ${data.LastName}`}</h3>
                                                        <p className="card-text">{data.Email}</p>
                                                        {(data.IsAgent) ? <span className='agent-badge'><FormattedMessage id="agent" /></span> : ''}

                                                        {data.UserType === 'Admin' ? (
                                                            <span className='badge bg-primary'>
                                                                <FormattedMessage id={data.UserType.toLowerCase()}/>
                                                            </span>
                                                        ) : data.UserType === 'Trainer' ? (
                                                            <span className='badge bg-success'>
                                                                <FormattedMessage id={data.UserType.toLowerCase()}/>
                                                            </span>
                                                        ) : (data.UserType === 'Personal' && data.AnyPaymentDone) ? (
                                                            <span className='badge bg-warning'>
                                                                <FormattedMessage id={data.UserType.toLowerCase()}/>
                                                            </span>
                                                        ) :
                                                        // This is a special requirement where, only for GUI purpose, we are showing 
                                                        // the Personal user as FREE if he/she hasn't done any payment.
                                                        (data.UserType === 'Personal' && !data.AnyPaymentDone) ? (
                                                            <span className='badge bg-info'>
                                                                <FormattedMessage id={"free"}/>
                                                            </span>
                                                        ) : (
                                                            <span className='badge bg-dark'>
                                                                {data.UserType}
                                                            </span>
                                                        )}
                                                        <div className='mt-4'>
                                                            <button className="btn btn-outline-info mx-1 btn-sm" onClick={() => handleEditProfilePopup(data.Email)} title={formatMessage('edit')}>
                                                                <svg height="492pt" viewBox="0 0 492.49284 492" width="492pt" xmlns="http://www.w3.org/2000/svg"><path d="m304.140625 82.472656-270.976563 270.996094c-1.363281 1.367188-2.347656 3.09375-2.816406 4.949219l-30.035156 120.554687c-.898438 3.628906.167969 7.488282 2.816406 10.136719 2.003906 2.003906 4.734375 3.113281 7.527344 3.113281.855469 0 1.730469-.105468 2.582031-.320312l120.554688-30.039063c1.878906-.46875 3.585937-1.449219 4.949219-2.8125l271-270.976562zm0 0" /><path d="m476.875 45.523438-30.164062-30.164063c-20.160157-20.160156-55.296876-20.140625-75.433594 0l-36.949219 36.949219 105.597656 105.597656 36.949219-36.949219c10.070312-10.066406 15.617188-23.464843 15.617188-37.714843s-5.546876-27.648438-15.617188-37.71875zm0 0" /></svg>
                                                            </button>
                                                            <button className='btn btn-sm btn-outline-danger mx-1 ' disabled={(data.Email == getEmail) ? true : false} onClick={() => handleDeleteClick(data.Id, data.Email)} title={formatMessage('delete')}>
                                                                <svg version="1.1" id="Layer_1" viewBox="0 0 512 512" >
                                                                    <g>
                                                                        <g>
                                                                            <path d="M62.205,150l26.569,320.735C90.678,493.865,110.38,512,133.598,512h244.805c23.218,0,42.92-18.135,44.824-41.265
        L449.795,150H62.205z M180.986,452c-7.852,0-14.458-6.108-14.956-14.063l-15-242c-0.513-8.276,5.771-15.395,14.033-15.908
        c8.569-0.601,15.381,5.757,15.908,14.033l15,242C196.502,444.632,189.721,452,180.986,452z M271,437c0,8.291-6.709,15-15,15
        c-8.291,0-15-6.709-15-15V195c0-8.291,6.709-15,15-15s15,6.709,15,15V437z M360.97,195.938l-15,242
        c-0.493,7.874-7.056,14.436-15.908,14.033c-8.262-0.513-14.546-7.632-14.033-15.908l15-242
        c0.513-8.276,7.764-14.297,15.908-14.033C355.199,180.543,361.483,187.662,360.97,195.938z"/>
                                                                        </g>
                                                                    </g>
                                                                    <g>
                                                                        <g>
                                                                            <path d="M451,60h-90V45c0-24.814-20.186-45-45-45H196c-24.814,0-45,20.186-45,45v15H61c-16.569,0-30,13.431-30,30
        c0,16.567,13.431,30,30,30c137.966,0,252.039,0,390,0c16.569,0,30-13.433,30-30C481,73.431,467.569,60,451,60z M331,60H181V45
        c0-8.276,6.724-15,15-15h120c8.276,0,15,6.724,15,15V60z"/>
                                                                        </g>
                                                                    </g>
                                                                </svg>
                                                            </button>
                                                            {
                                                                data.Email != getEmail &&
                                                                <LoaderButton variant="warning" className="btn btn-warning btn-sm mx-1" isLoading={emailSelectedForLogin === data.Email ? loginUserState.inProgress : false} disabled={(emailSelectedForLogin === "") ? false : true} onClick={() => { handleUserLoginByAdmin(data.Email) }} text="login" />
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </>
                        ) : (
                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <svg clip-rule="evenodd" fill-rule="evenodd" height="120" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 64 64" width="120" xmlns="http://www.w3.org/2000/svg"><g id="Exp-2.-F"><path d="m37.953 39.368 3.24-6.643h-14s-3.126 6.411-4.559 9.348c-.151.31-.132.675.051.968.183.292.503.47.848.47h6.027l-4.779 11.827c-.176.437-.024.938.366 1.202.39.265.912.221 1.253-.105 4.544-4.349 12.487-11.95 16.034-15.344.295-.283.388-.716.236-1.095s-.519-.628-.928-.628z" fill="#347bfa" /><g fill="#a4bbdb"><path d="m5.772 47.451c-.524.907-1.033 1.789-1.5 2.598-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c.467-.809.976-1.691 1.5-2.598.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366zm5.5-9.526s-.602 1.042-1.5 2.598c-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c.898-1.556 1.5-2.598 1.5-2.598.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366z" /><path d="m39.125 53.745c-.57.987-1.089 1.887-1.5 2.598-.276.478-.112 1.091.366 1.366.478.276 1.09.112 1.366-.366.411-.711.93-1.611 1.5-2.598.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366zm5.5-9.526s-.614 1.063-1.5 2.598c-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c.886-1.535 1.5-2.598 1.5-2.598.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366z" /><path d="m47.937 50.89c-.684 1.185-1.149 1.991-1.149 1.991-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c0 0 .465-.806 1.149-1.991.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366zm5.5-9.526s-.629 1.089-1.5 2.598c-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c.871-1.509 1.5-2.598 1.5-2.598.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366z" /><path d="m9.658 53.158c-.736 1.276-1.244 2.155-1.244 2.155-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c0 0 .508-.879 1.244-2.155.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366zm5.5-9.526s-.627 1.087-1.5 2.598c-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c.873-1.511 1.5-2.598 1.5-2.598.276-.478.112-1.09-.366-1.366s-1.09-.112-1.366.366z" /><path d="m20.48 47.123s-.691 1.196-1.5 2.598c-.276.478-.112 1.09.366 1.366s1.09.112 1.366-.366c.809-1.402 1.5-2.598 1.5-2.598.276-.478.112-1.091-.366-1.367-.478-.275-1.09-.111-1.366.367z" /></g><path d="m24.722 23.836c-.056-.493-.084-1.009-.084-1.549 0-8.278 6.721-15 15-15 7.417 0 13.583 5.395 14.787 12.47 4.046.396 7.213 3.812 7.213 7.962 0 4.398-3.557 7.972-7.949 8h-.051s-23.39.877-50.808-.735c-.24-.016-.435-.2-.464-.439s.116-.464.345-.537c5.091-.926 13.146-2.789 13.435-5.091-.326-.663-.508-1.41-.508-2.198 0-2.759 2.24-5 5-5 1.686 0 3.178.836 4.084 2.117z" fill="#e9f3fc" /><path d="m15.336 35.571c2.985-4.332 7.742-7.348 13.22-7.997 1.326-9.051 9.13-16.01 18.547-16.01 1.129 0 2.234.1 3.31.292 2.058 2.126 3.494 4.858 4.012 7.901 4.046.396 7.213 3.812 7.213 7.962 0 4.398-3.557 7.972-7.949 8h-.051s-16.638.624-38.302-.148z" fill="#cadcf0" /><path d="m32.683 20.719c.828 0 1.5 1.797 1.5 2.625 0 1.035-.672 1.875-1.5 1.875s-1.5-.84-1.5-1.875c0-.828.672-2.625 1.5-2.625z" fill="#738bab" /><path d="m37.265 18.635s-.725.834-1.627.834c-.903 0-1.628-.834-1.628-.834-.184-.205-.501-.222-.706-.038-.206.184-.223.5-.039.706 0 0 1.068 1.166 2.373 1.166s2.372-1.166 2.372-1.166c.184-.206.167-.522-.039-.706-.205-.184-.522-.167-.706.038z" fill="#738bab" /><path d="m47.265 18.635s-.725.834-1.627.834c-.903 0-1.628-.834-1.628-.834-.184-.205-.501-.222-.706-.038-.206.184-.223.5-.039.706 0 0 1.068 1.166 2.373 1.166s2.372-1.166 2.372-1.166c.184-.206.167-.522-.039-.706-.205-.184-.522-.167-.706.038z" fill="#738bab" /><path d="m37.638 28.219c.197 0 .382-.118.461-.308.021-.026.575-.692 2.539-.692 2.002 0 2.539.693 2.539.693s-.01-.025-.01-.025.471.332.471.332c-.383-.076-.099.063.162-.027s.4-.375.31-.636c0 0-.347-1.337-3.472-1.337-3.126 0-3.473 1.337-3.473 1.337-.09.261.049.546.31.636.054.018.109.027.163.027zm.47-.332-.001.004.002-.004z" fill="#738bab" /></g></svg>
                                <p className="noData text-muted text-center h4 mb-0">No User Available</p>
                                <p className="mb-3">Create more accounts to proceed</p>
                            </div>
                        )
                    }
                </div>
                {
                    <CustomPagination
                        onPageLimitChanged={onPageLimitChanged}
                        onPageChanged={onPageChanged}
                        pageSize={userPaginationState.PagingDetails.PageSize}
                        totalPages={userPaginationState.PagingDetails.TotalPages}
                        isRefreshPage={userPaginationState.PagingDetails.isRefreshPage}
                        disablePagination={ allUsers.length > 0 ? disablePagination : true }

                    />
                }
            </div>
        </>
    );
}

export default DeletePopupHOC(CreateProfileHOC(EditProfileHOC(observer(Users))));
